<template>
    <div class="modal-row2 modal-height-max show-brokers-component">
        <div class="show-brokers-toolbar">
            <div class="show-brokers-toolbar__search">
                <i class="icon-search1"></i>
                <input type="text" name="company" v-model="userFind" id="company"
                       class="form-control" @keyup="findUser"
                       placeholder="Pesquisar usuário">
            </div>
            <div class="show-brokers-toolbar__filter">
                <Select2 :settings="{ width: '100%', placeholder: 'Filtrar por'}" id="search"
                         name="search" v-model="filterStatus"
                         :options="optionsStatus" @select="filterBrokerStatus()"/>
            </div>
        </div>
        <div class="modal-body modal-row2 show-brokers-list">
            <div class="show-brokers-empty" v-if="allUsers && !allUsers.length">
                <i class="icon-user"></i>
                <strong>Nenhum usuário encontrado</strong>
                <small>Altere os filtros para visualizar outros usuários.</small>
            </div>
            <div class="show-brokers-user-card"
                 v-for="(user, key) in allUsers" :key="key"
                 :class="{
                     'show-brokers-user-card--selected': usersSelected?.includes(user),
                     'show-brokers-user-card--disabled': verifyIsUserLoged(user)
                 }">
                <div class="show-brokers-user-card__main">
                    <div class="form-check show-brokers-user-card__check">
                        <input class="form-check-input" type="checkbox" v-model="usersSelected" :value="user"
                               :id="`user${key}`" :disabled="verifyIsUserLoged(user)">
                        <label class="form-check-label" :for="`user${key}`">
                            <span class="show-brokers-user-card__avatar">
                                <i class="icon-user"></i>
                            </span>
                            <span class="show-brokers-user-card__text">
                                <strong>{{ user.text }}</strong>
                                <small v-if="verifyIsUserLoged(user)">Usuário logado</small>
                                <small v-else-if="user.active !== undefined">Usuário com acesso ao loteamento</small>
                                <small v-else>Sem acesso ao loteamento</small>
                            </span>
                        </label>
                    </div>
                </div>
                <div class="show-brokers-user-card__actions" v-if="user.active !== undefined">
                    <span class="show-brokers-status"
                          :class="user.active ? 'show-brokers-status--active' : 'show-brokers-status--inactive'">
                        {{ user.active ? "Ativo" : "Inativo" }}
                    </span>
                    <div class="custom-control custom-switch list-primary show-brokers-switch">
                        <input type="checkbox" class="custom-control-input" :value="user.id"
                               :disabled="verifyIsUserLoged(user)"
                               :id="`customSwitch${key}`" v-model="user.active" @change="updateUser(user)">
                        <label class="custom-control-label"
                               :for="`customSwitch${key}`">{{ user.active ? "Ativo" : "Inativo" }}</label>
                    </div>
                </div>
                <div v-else class="show-brokers-user-card__actions">
                    <span class="show-brokers-status show-brokers-status--pending">Sem acesso</span>
                    <div class="custom-control custom-switch list-primary show-brokers-switch">
                        <input type="checkbox" class="custom-control-input"
                               @click="setAddUserAllotmentModal(allotment, user, key)"
                               :value="user.id" :disabled="verifyIsUserLoged(user)"
                               :id="`customSwitch${key}`" v-model="user.active">
                        <label class="custom-control-label" :for="`customSwitch${key}`">Conceder acesso</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between show-brokers-footer">
            <span class="show-brokers-selected-counter" v-if="usersSelected?.length">
                {{ usersSelected.length }} usuário(s) selecionado(s)
            </span>
            <span v-else></span>
            <div class="show-brokers-footer__actions">
                <button class="btn btn-outline-danger mr-2" type="button"
                        v-if="usersSelected?.length"
                        @click="inactiveMultiples()">Inativar Selecionados
                </button>
                <button class="btn btn-primary mr-2" type="button"
                        v-if="usersSelected?.length"
                        @click="activeMultiples()">Ativar Selecionados
                </button>
                <button class="btn btn-secondary" data-dismiss="modal">{{ t('ACTIONS.CLOSE') }}
                </button>
            </div>
        </div>
        <transition name="fade">
            <div class="modal-mask" v-if="add">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog" role="document" style="margin-top: 0rem;">
                        <div class="modal-content">
                            <div class="modal-open">
                                <div class="modal-body modal-row2" style="max-height: calc(100vh - 200px);">
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex  mb-4">
                                            <h5 class="modal-title title-size d-flex ">
                                                {{ t('ALLOTMENT.REALLY_ACCESS_THIS_USER') }} ?</h5>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group d-flex ">
                                                <label>{{ t('LOTS.ALLOTMENT') }}:</label>
                                                <label class="ml-1 color-grey">{{ allotment.name }}</label>
                                            </div>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group d-flex ">
                                                <label>{{ t('RESERVE.REALTOR') }}: </label>
                                                <label class="ml-1 color-grey">{{ user.text }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-center">
                                <button class="btn btn-secondary mr-4" type="button" @click="close()">{{
                                        t("ACTIONS.CLOSE")
                                    }}
                                </button>
                                <button data-cy="user_index_add_phone_save" class="btn btn-primary" type="button"
                                        @click="createUserAllotment()">{{ t("ACTIONS.SAVE") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import User from '@/services/user';
import UserAllotment from "../../services/UserAllotment";
import Select2 from 'vue3-select2-component';
import jwt_decode from 'jwt-decode';

export default {
    name: "showBrokersComponent",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    components: {
        Select2
    },
    data() {
        return {
            usersSelected: [],
            allUsers: null,
            allotment: null,
            add: false,
            user: null,
            userAux: null,
            users: null,
            userFind: null,
            usersBackup: null,
            filterStatus: null,
            optionsStatus: [
                {
                    id: 0,
                    text: 'Ativo'
                },
                {
                    id: 1,
                    text: 'Inativo'
                },
                {
                    id: 3,
                    text: 'Sem acesso'
                },
                {
                    id: 4,
                    text: 'Limpar'
                }
            ]
        }
    },
    props: {
        allotmentIndex: {
            type: Object,
            required: true,
        }
    },
    mounted() {
        this.$store.commit('changeLoading', true);
        this.allotment = this.allotmentIndex;
        this.listAllBrokes();
    },
    watch: {
        allotmentIndex: function () {
            this.allotment = this.allotmentIndex;
            this.allUsers = null;
            this.add = false;
            this.user = null;
            this.userAux = null;
            this.users = null;
            this.userFind = null;
            this.usersBackup = null;
            this.filterStatus = null;
            this.listAllBrokes();
        }
    },
    methods: {
        verifyIsUserLoged(i) {
            if (localStorage.getItem('access_token')) {
                let userLoged = jwt_decode(localStorage.getItem('access_token'));
                if (userLoged) {
                    let id = i.user_id ? i.user_id : i.id;
                    return id === userLoged.idUsuario;
                }
                return false;
            }
            return false;
        },
        inactiveMultiples() {
            this.$swal.fire({
                title: `Realmente deseja inativar ${this.usersSelected?.length} Usuário(s) no Loteamento: ${this.allotment.name}`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    UserAllotment.activeMultiplesUsers(
                            {"users": this.usersSelected, "action": false},
                            this.allotment.id
                    ).then(() => {
                        this.allUsers = null;
                        this.add = false;
                        this.user = null;
                        this.userAux = null;
                        this.users = null;
                        this.userFind = null;
                        this.usersBackup = null;
                        this.filterStatus = null;
                        this.usersSelected = [];
                        this.listAllBrokes();
                    }).catch(() => {
                        this.toast.error('Não foi possivel atualizar');
                        this.$store.commit('changeLoading', false);
                    })
                }
            });
        },
        activeMultiples() {
            this.$swal.fire({
                title: `Realmente deseja ativar ${this.usersSelected?.length} Usuário(s) no Loteamento: ${this.allotment.name}`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    UserAllotment.activeMultiplesUsers(
                            {"users": this.usersSelected, "action": true},
                            this.allotment.id
                    ).then(() => {
                        this.allUsers = null;
                        this.add = false;
                        this.user = null;
                        this.userAux = null;
                        this.users = null;
                        this.userFind = null;
                        this.usersBackup = null;
                        this.filterStatus = null;
                        this.usersSelected = [];
                        this.listAllBrokes();
                    }).catch(() => {
                        this.toast.error('Não foi possivel atualizar');
                        this.$store.commit('changeLoading', false);
                    })
                }
            });
        },
        findUser() {
            this.userAux = [];
            this.filterStatus = null;
            this.users = this.usersBackup;
            this.users.forEach(user => {
                let nameUser = user.text.toUpperCase();
                let userFind = this.userFind.toUpperCase();
                if (nameUser.includes(userFind)) {
                    this.userAux.push(user);
                }
            })
            this.allUsers = this.userAux;
        },
        filterBrokerStatus() {
            this.userAux = [];
            this.users = this.usersBackup;
            this.userFind = null;
            if (this.filterStatus === '3') {
                this.users.forEach(user => {
                    let hasKey = false;
                    for (const userKey in user) {
                        if (userKey === 'active') hasKey = true;
                    }
                    if (!hasKey) this.userAux.push(user);
                })
            } else if (this.filterStatus === '1') {
                this.users.forEach(user => {
                    for (const userKey in user) {
                        if (userKey === 'active' && !user.active && user.active !== undefined) this.userAux.push(user);
                    }
                })
            } else if (this.filterStatus === '0') {
                this.users.forEach(user => {
                    for (const userKey in user) {
                        if (userKey === 'active' && user.active) this.userAux.push(user);
                    }
                })
            } else {
                this.filterStatus = null;
                this.userAux = this.usersBackup;
            }
            this.allUsers = this.userAux;
        },

        listAllBrokes() {
            this.$store.commit('changeLoading', true);
            UserAllotment.listBrokesByAllotment(this.allotment.id).then(async (resp) => {
                resp.data?.validations ? this.allUsers = [] : this.allUsers = resp.data;
                await User.listAll().then((resp) => {
                    let arr = [];
                    resp.data.forEach((item) => {
                        let inArray = false;
                        this.allUsers?.forEach(user => {
                            if (item.id === user.user_id) {
                                inArray = true;
                            }
                        })
                        if (!inArray) arr.push(item);
                    });
                    this.allUsers?.push(...arr);
                    this.$store.commit('changeLoading', false);
                });
                this.allUsers.sort(function (a, b) {
                    return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                });
                this.usersBackup = this.allUsers;
            })
        },

        setAddUserAllotmentModal(userAllotment, user) {
            this.add = false;
            this.user = user;
            this.name = user.text;
            this.add = true;
        },

        createUserAllotment() {
            this.$store.commit('changeLoading', true);
            let groups = [];
            groups = this.user.user_company?.user_scope_global?.groups?.map(i => {
                return{group_id:i.id}
            })
            const userAllotment = {
                allotment_id: this.allotment.id,
                description: this.allotment.name,
                user_company_id: this.user.user_company.id,
                groups: groups,
                user_id: this.user.id,
                max_number_reserves: this.allotment.max_number_reserve_per_realtor,
                active: true
            }
            UserAllotment.create(userAllotment, this.allotment.id).then((resp) => {
                this.add = false;
                this.allUsers?.forEach((item, key) => {
                    if (item.id === resp.data.user_id) {
                        this.allUsers[key] = resp.data;
                        this.allUsers[key].text = this.user.text;
                        this.usersBackup.forEach((backup, key2) => {
                            if (backup.id === resp.data.user_id) {
                                this.usersBackup[key2] = this.allUsers[key];
                            }
                        })
                    }
                });
                this.filterBrokerStatus();
                this.toast.success(this.t('ALLOTMENT.USER_CREATE_IN_ALLOTMENT'));
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                        this.allUsers?.forEach((item, key) => {
                            if (item.id === this.user.id) {
                                this.allUsers[key].active = undefined;
                            }
                        })
                        this.add = false;
                        this.$store.commit('changeLoading', false)
                    }
            );
        },
        close() {
            this.allUsers?.forEach((item, key) => {
                if (item.id === this.user.id) {
                    this.allUsers[key].active = undefined;
                }
            })
            this.add = false;
        },
        updateUser(user) {
            this.$store.commit('changeLoading', true);
            UserAllotment.updateIsRealtor(user).then((resp) => {
                this.usersBackup.forEach(item => {
                    if (item.id === resp.data.user_id)
                        item.active = resp.data.active;
                })
                this.filterBrokerStatus();
                this.$store.commit('changeLoading', false);
                if (resp.data.active) {
                    this.toast.success(this.t('ALLOTMENT.USER_ALLOTMENT_ACTIVED'));
                } else {
                    this.toast.success(this.t('ALLOTMENT.USER_ALLOTMENT_DESACTIVED'));
                }
            }).catch((err) => {
                this.allUsers?.forEach((item, key) => {
                    if (item.id === user.id) {
                        this.allUsers[key].active = !user.active;
                    }
                })
                this.toast.error(err.response.data.message);
                this.$store.commit('changeLoading', false);
            });
        }
    }
}
</script>

<style scoped>
.show-brokers-component {
    background: #f8fafb;
}

.show-brokers-toolbar {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    display: flex;
    gap: 0.75rem;
    margin: 0.85rem 1rem 0.35rem;
    padding: 0.75rem;
    position: sticky;
    top: 0;
    z-index: 2;
}

.show-brokers-toolbar__search {
    align-items: center;
    background: #f8fbfa;
    border: 1px solid #dcebe7;
    border-radius: 12px;
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    padding: 0 0.75rem;
}

.show-brokers-toolbar__search i {
    color: #0e5e4e;
    font-size: 0.9rem;
    margin-right: 0.5rem;
}

.show-brokers-toolbar__search .form-control {
    background: transparent;
    border: 0;
    box-shadow: none;
    min-height: 38px;
    padding-left: 0;
}

.show-brokers-toolbar__filter {
    flex: 0 0 220px;
}

.show-brokers-list {
    max-height: 52vh;
    padding: 0.75rem 1rem 1rem;
}

.show-brokers-user-card {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
    display: flex;
    gap: 0.75rem;
    justify-content: space-between;
    margin-bottom: 0.65rem;
    padding: 0.85rem 1rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.show-brokers-user-card:hover {
    border-color: rgba(14, 94, 78, 0.28);
    box-shadow: 0 12px 26px rgba(14, 94, 78, 0.08);
    transform: translateY(-1px);
}

.show-brokers-user-card--selected {
    border-color: #0e5e4e;
    box-shadow: 0 12px 26px rgba(14, 94, 78, 0.12), 0 0 0 3px rgba(14, 94, 78, 0.08);
}

.show-brokers-user-card--disabled {
    opacity: 0.68;
}

.show-brokers-user-card__main {
    min-width: 0;
}

.show-brokers-user-card__check {
    margin-bottom: 0;
    padding-left: 1.45rem;
}

.show-brokers-user-card__check .form-check-input {
    margin-top: 1rem;
}

.show-brokers-user-card__check .form-check-label {
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 0.75rem;
    margin-bottom: 0;
}

.show-brokers-user-card__avatar {
    align-items: center;
    background: #e7f4f0;
    border-radius: 12px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 38px;
    height: 38px;
    justify-content: center;
    width: 38px;
}

.show-brokers-user-card__text {
    min-width: 0;
}

.show-brokers-user-card__text strong {
    color: #173b34;
    display: block;
    font-size: 0.9rem;
    line-height: 1.2;
}

.show-brokers-user-card__text small {
    color: #6b7c78;
    display: block;
    font-size: 0.75rem;
    margin-top: 0.15rem;
}

.show-brokers-user-card__actions {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    text-align: right;
}

.show-brokers-status {
    border-radius: 999px;
    display: inline-flex;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    padding: 0.35rem 0.62rem;
    text-transform: uppercase;
    white-space: nowrap;
}

.show-brokers-status--active {
    background: #e7f4f0;
    color: #0e5e4e;
}

.show-brokers-status--inactive {
    background: #fff5f5;
    color: #b42318;
}

.show-brokers-status--pending {
    background: #fff7e6;
    color: #a15c07;
}

.show-brokers-switch {
    margin-bottom: 0;
    min-height: auto;
}

.show-brokers-switch .custom-control-label {
    color: #163f36;
    cursor: pointer;
    font-size: 0.78rem;
    font-weight: 700;
    margin-bottom: 0;
}

.show-brokers-footer {
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    gap: 0.75rem;
}

.show-brokers-selected-counter {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 0.76rem;
    font-weight: 800;
    padding: 0.45rem 0.75rem;
}

.show-brokers-footer__actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.show-brokers-empty {
    align-items: center;
    background: #ffffff;
    border: 1px dashed #d5dde5;
    border-radius: 14px;
    color: #6b7c78;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 160px;
    padding: 1.5rem;
    text-align: center;
}

.show-brokers-empty i {
    color: #0e5e4e;
    font-size: 1.6rem;
    margin-bottom: 0.5rem;
}

.show-brokers-empty strong {
    color: #173b34;
}

@media (max-width: 575px) {
    .show-brokers-toolbar,
    .show-brokers-user-card,
    .show-brokers-footer {
        align-items: stretch;
        flex-direction: column;
    }

    .show-brokers-toolbar__filter {
        flex-basis: auto;
        width: 100%;
    }

    .show-brokers-user-card__actions {
        align-items: flex-start;
        text-align: left;
    }

    .show-brokers-footer__actions,
    .show-brokers-footer__actions .btn {
        width: 100%;
    }

    .show-brokers-footer__actions .btn {
        margin-bottom: 0.5rem;
        margin-right: 0 !important;
    }
}

</style>
